import delay from 'lodash/delay';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'button-component';
import Icon from 'icon-component';

class Notification extends Component {
    static propTypes = {
        autoClose: PropTypes.bool,
        showClose: PropTypes.bool,
        notificationRemoved: PropTypes.func,
        type: PropTypes.oneOf(['success', 'error', 'warning']),
        zIndex: PropTypes.number,
        message: PropTypes.string,
        duration: PropTypes.number
    };
    static defaultProps = {
        duration: 2000,
        type: 'success',
        autoClose: true,
        showClose: true
    };
    state = {
        hidden: true,
        marginTop: 0
    };

    constructor(props) {
        super(props);

        this._ANIMATION_TIME = 200;
    }

    componentDidMount() {
        delay(() => {
            this._startPos = -this._notification.offsetHeight;

            this._show();
        }, this._ANIMATION_TIME);
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            notificationRemoved
        } = this.props;

        if (!prevState.hidden && this.state.hidden) {
            if (notificationRemoved) {
                notificationRemoved();
            }
        }
    }

    _onCloseClicked = evt => {
        evt.preventDefault();

        this._hide();
    }

    _show = () => {
        const {
            autoClose,
            duration
        } = this.props;

        this.setState({
            marginTop: this._startPos,
            hidden: false
        });

        if (autoClose) {
            delay(() => {
                this._hide();
            }, duration);
        }
    }

    _hide = () => {
        this.setState({
            hidden: true
        });
    }

    render() {
        const {
            showClose,
            type,
            zIndex,
            message
        } = this.props;
        const {
            marginTop,
            hidden
        } = this.state;
        const classes = classNames(
            'notification',
            {'notification-show': !hidden},
            type
        );

        return (
            <div
                ref={node => {this._notification = node;}}
                className={classes}
                style={{
                    marginTop,
                    zIndex
                }}
            >
                <div className="container">
                    <div className="notification-content">
                        <p>{message}</p>
                    </div>
                </div>
                {showClose &&
                    <Button
                        className="btn-close"
                        onClick={this._onCloseClicked}
                    >
                        <Icon name="times" />
                    </Button>
                }
            </div>
        );
    }
}

export default Notification;



// WEBPACK FOOTER //
// ./frontend/src/js/components/notification/Notification.jsx